import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
 
import AllBlog from "../components/blog/AllBlog";
import { Header, Footer } from "../shared";

const AllBlogPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <AllBlog />
      <Footer />
    </div>
  );
};

export default AllBlogPage;
